export default __webpack_public_path__ + "static/media/518783d9a4effd23e1fbbf4d47c0734a1581356967364.7a7db638.webp";